import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

import Vuesax from 'vuesax' //import dependency
import 'vuesax/dist/vuesax.css' // import css style
import 'material-icons/iconfont/material-icons.css' //icons
Vue.use(Vuesax) // implement Vuesax throughout the application

//fillters
import './filters/filters'

//vee validate
import VeeValidate, {Validator} from 'vee-validate';
Vue.use(VeeValidate);

import {dictionary} from "./plugins/customValidate";
Validator.localize(dictionary);
const validator = new Validator({});
validator.localize('fa');

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
